import { combineReducers }  from 'redux-immutablejs';    
import products             from './products';

export default combineReducers({
    products
})